import { createSlice } from "@reduxjs/toolkit";
import { EFileQuestion } from "../models/e-file/e-file-question";
import { EFileOption } from "../models/e-file/e-file-option";

interface EFileState {
  eFileList;
  eFileQuestions: {
    List?: EFileQuestion[];
    MAIN?: any[];
    ERROR?: any[];
  };
  eFileOptions:EFileOption[];
  activeEFileOption: EFileOption;
}

const initialState: EFileState = {
  eFileOptions: null,
  eFileList: null,
  eFileQuestions: null,
  activeEFileOption: null
};

const eFileStore = createSlice({
  name: "eFile",
  initialState,
  reducers: {
    getEFileQuestions: (state) => {
      state.eFileQuestions;
      },
    updateActiveEFileOption: (state, action) => {
      state.activeEFileOption = {
        ...state.activeEFileOption,
        ...action.payload
      };
    },
    updateEFileOptions: (state, action) => {
      state.eFileOptions = {
        ...state.eFileOptions,
        ...action.payload,
      };
    },
    updateEFileQuestions: (state, action) => {
      if (!action.payload?.List) {
        state.eFileQuestions.List = action.payload;
      }
      else {
        state.eFileQuestions = {
        ...state.eFileQuestions,
        ...action.payload
        };
      }
    },
    getActiveEFileOption: (state) => {
      state.eFileOptions;
    },
    resetEFileQuestions: (state) => {
      state.eFileQuestions = null;
    },
    resetAllEFile: (state) => {
      state.eFileQuestions = null;
      state.eFileOptions = null;
      state.activeEFileOption = null;
    }
  }
});

export const { updateEFileOptions, updateEFileQuestions, getEFileQuestions, resetEFileQuestions, updateActiveEFileOption, getActiveEFileOption, resetAllEFile } = eFileStore.actions;

export default eFileStore.reducer;
